import { styled } from '@mui/material/styles'
import Box from '@/components/common/Box'
import { colors, radius, sizing, spacing, skeletonOpacity } from '@/styles/designTokens'
import { skeletonPulse } from '@/styles/animations'

export const SkeletonBlock = styled(Box)({
	backgroundColor: colors.overlayMedium,
	borderRadius: radius.card,
	animation: `${skeletonPulse} 2.4s ease-in-out infinite`,
	'@media (prefers-reduced-motion: reduce)': {
		animation: 'none',
		opacity: skeletonOpacity.reduced,
	},
})

export const SkeletonBlockLight = styled(SkeletonBlock)({
	backgroundColor: colors.overlayLight,
})

// Matches CardRoot dimensions — cardHeightMobile/cardHeightDesktop
export const SkeletonCard = styled(Box)(({ theme }) => ({
	display: 'flex',
	flexDirection: 'row',
	width: '100%',
	border: `1px solid ${colors.borderSubtle}`,
	borderRadius: radius.card,
	overflow: 'hidden',
	backgroundColor: colors.surfaceWhite,
	height: sizing.cardHeightMobile,
	[theme.breakpoints.up('lg')]: {
		height: sizing.cardHeightDesktop,
	},
}))

export const SkeletonTextBody = styled(Box)({
	flex: '1 1 auto',
	padding: spacing.lg,
	display: 'flex',
	flexDirection: 'column',
})

export const SkeletonInfoGroup = styled(Box)({
	flex: '1 1 auto',
	display: 'flex',
	flexDirection: 'column',
	gap: spacing.xs,
})

export const SkeletonPriceRow = styled(Box)({
	height: sizing.skeletonTextHeightMd,
	width: sizing.skeletonPriceWidth,
	marginTop: `${spacing.md}px`,
	borderRadius: radius.badge,
})

export const SkeletonImagePlaceholder = styled(Box)({
	width: sizing.cardImageWidth,
	flexShrink: 0,
	backgroundColor: colors.overlayLight,
	position: 'relative',
})

export const SkeletonAddButton = styled(Box)({
	position: 'absolute',
	bottom: sizing.addButtonOffset,
	right: sizing.addButtonOffset,
	width: sizing.addButton,
	height: sizing.addButton,
	borderRadius: radius.circle,
	backgroundColor: colors.overlayMedium,
})

export const SkeletonCategoryRow = styled(Box)({
	marginBottom: `${spacing.xxl}px`,
	paddingTop: `${spacing.xl}px`,
	paddingLeft: `${spacing.lg}px`,
	paddingRight: `${spacing.lg}px`,
})

export const SkeletonItemGrid = styled(Box)({
	display: 'flex',
	flexWrap: 'wrap',
	alignItems: 'flex-start',
	gap: `${spacing.lg}px`,
})
